import React, { useEffect, useState } from "react";
import FlexBox from "../FlexBox";
import Pagination from "../pagination/Pagination";
import ProductCardList from "../product-cards/ProductCardList";
import { SemiSpan } from "../Typography";
import { useCategoryPageContext } from "../../contexts/app/CategoryPageContext";
import InfiniteScroll from 'react-infinite-scroller';
import Grid from "../grid/Grid";
import { useAppContext } from "../../contexts/app/AppContext";
import PuffLoader from 'react-spinners/PuffLoader'
import Backdrop from "../Backdrop";

export interface CategoryPageProductsListProps { }

const CategoryPageProductsList: React.memo<CategoryPageProductsListProps> = () => {

  const { setFooterVisible, fixPrice, setIsCategoryPage } = useAppContext();

  const { categoryProducts, hasMore, loading, scrollDir, handleOnWheel, handleClick, threshold, filterApply } = useCategoryPageContext();
  //console.log(categoryProducts);
  useEffect(() => {
    if (hasMore) {
      setIsCategoryPage(true)
      setFooterVisible(false)

    } else {
      setFooterVisible(true)

    }
  }, [hasMore])

  return (
    <div id="scrollableDiv" style={{
      overflow: 'auto',
      display: 'flex',
      flexDirection: 'column-reverse',
    }}>

      <Grid onMouseMove={(event: any) => handleOnWheel(event)} onTouchMove={(event: any) => handleOnWheel(event)} onWheel={(event: any) => handleOnWheel(event)} >
        <InfiniteScroll threshold={threshold} isReverse={scrollDir == 'up' ? true : false} loadMore={loading} hasMore={hasMore} >
          {categoryProducts.map((product, ind) => (
            <Grid id={product.id} key={product.id}>

              <ProductCardList mb="1.25rem"
                onClick={((e) => handleClick(product.id, product.url_key))}
                id={product.id}
                urlKey={product.url_key}
                imgUrl={product.base_image['category_grid_image_url']}
                title={product.name}
                rating={4}
                price={product.show_total_price ? fixPrice(parseFloat(product.price)) : fixPrice(parseFloat(product?.product_price_discount))}
                off={product.off}
                key={product.id}
                variants={product.variants ?? []}
                attributes={product.attributes}
                desc={product.description}
                sku={product.sku}
                initialPrice={product.is_package || !product.show_total_price ? fixPrice(parseFloat(product.product_price)) : fixPrice(parseFloat(product.initialPrice))}
              />

            </Grid>
          ))}

        {/* <FlexBox
            flexWrap="wrap"
            justifyContent="space-between"
            alignItems="center"
            mt="32px">


          </FlexBox> */}
          <PuffLoader
            color={'royalblue'}
            loading={hasMore}
            className='puffloader'
            size={60}
            aria-label="Loading Spinner"
            data-testid="loader"
          />

          <Backdrop open={filterApply} />
          
        </InfiniteScroll>
      </Grid>
    </div>

  );
};

export default CategoryPageProductsList;
